<template>
    <div class="border-0 mb-primary" style="">
        <app-overlay-loader v-if="preloader" />
        <form ref="form" :data-url="'public/app/candidates'" class="mb-0 p-3 pt-5 card" :class="{ 'loading-opacity': preloader }" style="max-width: 650px; margin: 0 auto;">
            <div class="p-3">
                <svg width="auto" height="auto" viewBox="0 0 auto auto" fill="none" xmlns="http://www.w3.org/2000/svg" style="height: 56px">
                    <g clip-path="url(#clip0_703_11496)">
                        <path d="M2.38516 4.77033C3.70245 4.77033 4.77033 3.70245 4.77033 2.38516C4.77033 1.06787 3.70245 0 2.38516 0C1.06787 0 0 1.06787 0 2.38516C0 3.70245 1.06787 4.77033 2.38516 4.77033Z" fill="currentColor"></path>
                        <path d="M10.0014 4.77033C11.3187 4.77033 12.3865 3.70245 12.3865 2.38516C12.3865 1.06787 11.3187 0 10.0014 0C8.68409 0 7.61621 1.06787 7.61621 2.38516C7.61621 3.70245 8.68409 4.77033 10.0014 4.77033Z" fill="currentColor"></path>
                        <path d="M17.6147 4.77033C18.929 4.77033 19.9998 3.70138 19.9998 2.38516C19.9998 1.06895 18.9309 0 17.6147 0C16.2984 0 15.2295 1.06895 15.2295 2.38516C15.2295 3.70138 16.2984 4.77033 17.6147 4.77033Z" fill="currentColor"></path>
                        <path d="M2.38516 7.61572C1.07085 7.61572 0 8.68467 0 10.0009C0 11.3171 1.06895 12.3861 2.38516 12.3861C3.70138 12.3861 4.77033 11.3171 4.77033 10.0009C4.77033 8.68467 3.70138 7.61572 2.38516 7.61572Z" fill="currentColor"></path>
                        <path d="M10.0014 7.61572C8.68706 7.61572 7.61621 8.68467 7.61621 10.0009C7.61621 11.3171 8.68516 12.3861 10.0014 12.3861C11.3176 12.3861 12.3865 11.3171 12.3865 10.0009C12.3865 8.68467 11.3176 7.61572 10.0014 7.61572Z" fill="currentColor"></path>
                        <path d="M17.6147 7.61572C16.3003 7.61572 15.2295 8.68467 15.2295 10.0009C15.2295 11.3171 16.2984 12.3861 17.6147 12.3861C18.9309 12.3861 19.9998 11.3171 19.9998 10.0009C19.9998 8.68467 18.9309 7.61572 17.6147 7.61572Z" fill="currentColor"></path>
                        <path d="M2.38516 15.2297C1.07085 15.2297 0 16.2987 0 17.6149C0 18.9311 1.06895 20.0001 2.38516 20.0001C3.70138 20.0001 4.77033 18.9311 4.77033 17.6149C4.77033 16.2987 3.70138 15.2297 2.38516 15.2297Z" fill="currentColor"></path>
                        <path d="M10.0014 15.2297C8.68706 15.2297 7.61621 16.2987 7.61621 17.6149C7.61621 18.9311 8.68516 20.0001 10.0014 20.0001C11.3176 20.0001 12.3865 18.9311 12.3865 17.6149C12.3865 16.2987 11.3176 15.2297 10.0014 15.2297Z" fill="currentColor"></path>
                        <path d="M17.6147 15.2297C16.3003 15.2297 15.2295 16.2987 15.2295 17.6149C15.2295 18.9311 16.2984 20.0001 17.6147 20.0001C18.9309 20.0001 19.9998 18.9311 19.9998 17.6149C19.9998 16.2987 18.9309 15.2297 17.6147 15.2297Z" fill="currentColor"></path>
                        <path d="M40.8582 17.3525L36.7897 12.3463H31.6237V17.3525H29.0312V2.39478H37.2081C41.8758 2.39478 43.8101 4.31013 43.8101 7.2602C43.8101 9.6739 42.454 11.5474 39.6808 12.1466L43.9889 17.3525H40.8582ZM31.6237 10.1532H37.6665C40.1202 10.1532 41.3356 9.07666 41.3356 7.38003C41.3356 5.68341 40.2191 4.58783 37.2062 4.58783H31.6218V10.1532H31.6237Z" fill="currentColor"></path>
                        <path d="M56.5534 12.8046H47.5586C47.9181 14.6401 49.3142 15.7566 51.8268 15.7566C53.084 15.7566 55.0374 15.5569 56.2738 14.9786L56.095 16.894C54.7578 17.5122 52.6846 17.7518 51.5072 17.7518C47.3779 17.7518 45.0859 15.418 45.0859 11.8688C45.0859 8.31958 47.3988 5.96484 51.1097 5.96484C55.1592 5.96484 57.4511 8.51739 56.5553 12.8065L56.5534 12.8046ZM51.1078 7.75847C48.9129 7.75847 47.6765 9.11463 47.4787 11.1498H54.2196C54.4992 9.2744 53.4017 7.75847 51.1078 7.75847Z" fill="currentColor"></path>
                        <path d="M66.9845 15.8764C65.3488 17.0538 63.2755 17.7518 61.44 17.7518C59.6046 17.7518 58.1895 16.9549 58.1895 15.1783C58.1895 12.8445 61.2004 11.3096 66.9255 11.3096V10.0333C66.9255 8.75705 65.8281 8.03807 63.9146 8.03807C62.6174 8.03807 60.3235 8.45652 58.7087 9.29532L58.8875 7.16123C60.4225 6.36427 62.8761 5.96484 64.2132 5.96484C67.8024 5.96484 69.3982 7.57968 69.3982 10.0542V17.3543H66.9255L66.9845 15.8783V15.8764ZM60.8409 14.8398C60.8409 15.7775 61.6379 16.1161 62.6764 16.1161C63.8937 16.1161 65.5884 15.5569 66.9236 14.621V12.7666C63.4334 12.7666 60.8409 13.3657 60.8409 14.8417V14.8398Z" fill="currentColor"></path>
                        <path d="M75.8789 12.4261L74.4828 13.4837V17.3524H71.9893V2.17603H74.4828V10.9711L80.3259 6.36433H83.4567L77.7125 10.8912L84.1338 17.3524H80.9821L75.877 12.4261H75.8789Z" fill="currentColor"></path>
                        <path d="M91.2357 17.7519C88.5633 17.7519 87.0075 16.2759 87.0075 13.6834V8.43759H84.1943V6.36245H87.0075V5.04624L89.4801 3.23169V6.36245H95.443V8.43759H89.4801V13.1642C89.4801 14.8189 90.4178 15.6768 92.1125 15.6768C93.2899 15.6768 94.6061 15.2184 95.443 14.779L95.2642 16.8541C94.2276 17.3334 92.7307 17.7519 91.2357 17.7519Z" fill="currentColor"></path>
                        <path d="M102.923 17.7518C99.0148 17.7518 96.4014 15.418 96.4014 11.8688C96.4014 8.31958 99.0148 5.96484 102.923 5.96484C106.832 5.96484 109.465 8.29865 109.465 11.8688C109.465 15.4389 106.851 17.7518 102.923 17.7518ZM102.923 8.03807C100.491 8.03807 98.895 9.53308 98.895 11.8669C98.895 14.2007 100.491 15.6767 102.923 15.6767C105.356 15.6767 106.973 14.1817 106.973 11.8669C106.973 9.5521 105.377 8.03807 102.923 8.03807Z" fill="currentColor"></path>
                        <path d="M111.52 6.36424H114.013L113.914 8.05896C115.63 6.6039 118.262 5.74607 120.178 6.08464L119.938 8.47741C117.983 7.93913 115.27 8.61626 114.015 9.59391V17.3524H111.521V6.36424H111.52Z" fill="currentColor"></path>
                    </g>
                </svg>
            </div>

            <div class="col-sm-12">
                <div class="pb-2">
                    <h3>{{ this.body.title }}</h3>
                    <p v-if="this.body.advert" v-html="this.body.advert"></p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label class="col-sm-12">
                        <strong>Jméno *</strong>
                    </label>
                    <app-input class="col-sm-12 mb-3" type="text" v-model="inputs.name" :required="true" />
                </div>
                <div class="col-sm-6">
                    <label class="col-sm-12">
                        <strong>Příjmení *</strong>
                    </label>
                    <app-input class="col-sm-12 mb-3" type="text" v-model="inputs.surname" :required="true" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label class="col-sm-12">
                        <strong>E-mail *</strong>
                    </label>
                    <app-input class="col-sm-12 mb-3" type="email" v-model="inputs.email" :required="true" />
                </div>
                <div class="col-sm-6">
                    <label class="col-sm-12">
                        <strong>Telefon *</strong>
                    </label>
                    <app-input class="col-sm-12 mb-3" type="tel-input" v-model="inputs.phone" :required="true" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label class="col-sm-12">
                        <strong>Web</strong>
                    </label>
                    <app-input class="col-sm-12 mb-3" type="text" v-model="inputs.meta_web" />
                </div>
                <div class="col-sm-6">
                    <label class="col-sm-12">
                        <strong>Portfolio (Dropbox, Issue apod.)</strong>
                    </label>
                    <app-input class="col-sm-12 mb-3" type="text" v-model="inputs.meta_external_attachment" />
                </div>
            </div>
            <div class="row pl-3 pr-3">
                <label class="col-sm-12">
                    <strong>Příloha</strong>
                </label>
                <app-input class="col-sm-12 mb-3" type="file" :label="$t('upload_your_file')" v-model="inputs.file" />
                <br />
                <small class="col-sm-12">Maximální velikost přílohy: 20 MB</small>
                <br />
                <br />
                <small class="col-sm-12">* Takto označené položky jsou povinné</small>
            </div>

            <div class="text-center mt-2">
                <button type="submit" class="btn btn-primary btn-with-icon" @click.prevent="submit">
                    <i class="custom-icon-set custom-icon-set-check"></i>
                    Odeslat
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin.js";
import GlobalHelperMixin from "../../../../../../Mixins/global/GlobalHelperMixin";

export default {
    name: "PublicCareerSite",
    mixins: [FormMixin, GlobalHelperMixin],
    props: {
        uploadedImage: {
            required: false,
            type: Object,
        },
    },
    watch: {
        uploadedImage: {
            // the callback will be called immediately after the start of the observation
            immediate: true,
            handler(val, oldVal) {
                // If new file has been uploaded
                if (oldVal) {
                    this.insertImageToChosenPlace(val.input.default_file);
                }
            },
        },
    },
    data() {
        return {
            preloader: false,
            tableCommentId: "comments-table",
            finishedGetData: false,
            chosenPlace: "",
            // jmeno, kontakt, telefon, email, uplaod souboru, dropbox file.
            inputs: {
                name: "",
                surname: "",
                phone: "",
                email: "",
                careerId: "",
                dropzone_file: "",
                meta_external_attachment: "",
                meta_web: "",
            },
            body: {
                title: "",
                advert: "",
            },
        };
    },
    created() {
        if (this.selectedUrl) {
            this.modalTitle = this.$t("edit");
            this.preloader = true;
        } else {
            this.finishedGetData = true;
        }

        let jobId = window.location.href.replace(/(.*)kariera/, "");
        this.inputs.careerId = jobId.replace(/\D/g, "");

        let url = "public/app/careers/" + jobId.replace(/\D/g, "");
        this.axiosGet(url)
            .then((response) => {
                this.body.title = response.data.title;
                this.body.advert = response.data.advert;
            })
            .catch(({ response }) => {})
            .finally(() => {});

        window.onscroll = function() {
            var pageHeight = document.documentElement.offsetHeight,
                windowHeight = window.innerHeight,
                scrollPosition = window.scrollY || window.pageYOffset || document.body.scrollTop + ((document.documentElement && document.documentElement.scrollTop) || 0);

            if (scrollPosition > 193 && window.innerWidth > 991) {
                $(".right-indent").addClass("fixed");
            } else {
                $(".right-indent").removeClass("fixed");
            }

            $(".main-headline .note-editable").trigger("click");
        };
    },
    mounted() {
        this.inputs.source = 4;
    },
    methods: {
        beforeSubmit() {
            this.preloader = true;
        },
        submit() {
            if(this.inputs.file){
                let formData = new FormData();
                formData.append('name', this.inputs.name);
                formData.append('surname', this.inputs.surname);
                formData.append('email', this.inputs.email);
                formData.append('phone', this.inputs.phone);
                formData.append('careerId', this.inputs.careerId);

                formData.append('meta_web', this.inputs.meta_web);
                formData.append('meta_external_attachment', this.inputs.meta_external_attachment);

                formData.append('attachment', this.inputs.file);
                this.save(formData);
            } else {
                this.save(this.inputs);
            }

            
        },
        afterSuccessFromGetEditData(response) {
            this.body = response.data;
        },
        afterFinalResponse() {},
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.finishedGetData = true;
        },
        afterSuccess(res) {
            this.$toastr.s("Úspěšně odesláno!");
            this.preloader = false;

            setTimeout(function() {
                window.location.reload();
            }, 2500);
        },
        afterError(res) {
            this.$toastr.e(res.data.message);
        },
        clear() {
            this.inputs = {};
            this.fieldStatus = {
                isSubmit: false,
            };
        },

        /**
         * Image upload and set to Chosen Place
         */
        addImageTo(place) {
            this.chosenPlace = place;
            this.$emit("getImageAction", place);
        },
        insertImageToChosenPlace(url) {
            if (this.chosenPlace == "logo") {
                this.inputs.images.logo = [];
                this.inputs.images.logo.push(url);
            } else if (this.chosenPlace == "header") {
                this.inputs.images.header = [];
                this.inputs.images.header.push(url);
            } else if (this.chosenPlace == "body1") {
                this.inputs.images.body1.push(url);
            } else if (this.chosenPlace == "body2") {
                this.inputs.images.body2.push(url);
            } else if (this.chosenPlace == "body3") {
                this.inputs.images.body3.push(url);
            } else if (this.chosenPlace == "body4") {
                this.inputs.images.body4.push(url);
            } else if (this.chosenPlace == "fullsize") {
                this.inputs.images.fullsize.push(url);
            } else if (this.chosenPlace == "prefooter") {
                this.inputs.images.prefooter.push(url);
            } else if (this.chosenPlace == "footer") {
                this.inputs.images.footer.push(url);
            }
        },
        removeImageFromChosenPlace(url, place) {
            if (place == "logo") {
                for (var i = 0; i <= this.inputs.images.logo.length - 1; i++) {
                    if (this.inputs.images.logo[i] == url) {
                        this.inputs.images.logo.splice(i--, 1);
                    }
                }
            } else if (place == "header") {
                for (var i = 0; i <= this.inputs.images.header.length - 1; i++) {
                    if (this.inputs.images.header[i] == url) {
                        this.inputs.images.header.splice(i--, 1);
                    }
                }
            } else if (place == "body1") {
                for (var i = 0; i <= this.inputs.images.body1.length - 1; i++) {
                    if (this.inputs.images.body1[i] == url) {
                        this.inputs.images.body1.splice(i--, 1);
                    }
                }
            } else if (place == "body2") {
                for (var i = 0; i <= this.inputs.images.body2.length - 1; i++) {
                    if (this.inputs.images.body2[i] == url) {
                        this.inputs.images.body2.splice(i--, 1);
                    }
                }
            } else if (place == "body3") {
                for (var i = 0; i <= this.inputs.images.body3.length - 1; i++) {
                    if (this.inputs.images.body3[i] == url) {
                        this.inputs.images.body3.splice(i--, 1);
                    }
                }
            } else if (place == "body4") {
                for (var i = 0; i <= this.inputs.images.body4.length - 1; i++) {
                    if (this.inputs.images.body4[i] == url) {
                        this.inputs.images.body4.splice(i--, 1);
                    }
                }
            } else if (place == "fullsize") {
                for (var i = 0; i <= this.inputs.images.fullsize.length - 1; i++) {
                    if (this.inputs.images.fullsize[i] == url) {
                        this.inputs.images.fullsize.splice(i--, 1);
                    }
                }
            } else if (place == "prefooter") {
                for (var i = 0; i <= this.inputs.images.prefooter.length - 1; i++) {
                    if (this.inputs.images.prefooter[i] == url) {
                        this.inputs.images.prefooter.splice(i--, 1);
                    }
                }
            } else if (place == "footer") {
                for (var i = 0; i <= this.inputs.images.footer.length - 1; i++) {
                    if (this.inputs.images.footer[i] == url) {
                        this.inputs.images.footer.splice(i--, 1);
                    }
                }
            }
        },
        changeColor() {
            let root = document.documentElement;
            root.style.setProperty("--careers-color", this.header.color);
        },
        changeImageOrder(arr, from, to) {
            return arr.reduce((prev, current, idx, self) => {
                if (from === to) {
                    prev.push(current);
                }
                if (idx === from) {
                    return prev;
                }
                if (from < to) {
                    prev.push(current);
                }
                if (idx === to) {
                    prev.push(self[from]);
                }
                if (from > to) {
                    prev.push(current);
                }
                return prev;
            }, []);
        },
    },
};
</script>